import { takeLatest, put, call } from 'redux-saga/effects';

import { listBaixaManualEstoqueProducao } from '../service';
import {
  TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO,
  TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING,
  TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS,
  TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE
} from '../actionTypes';

function* sagaListBaixaManualEstoqueProducao(action) {
  yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING })

  try {
    const table = yield call(listBaixaManualEstoqueProducao, action.args)
    yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListBaixaManualEstoqueProducao() {
  yield takeLatest(TABLE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO, sagaListBaixaManualEstoqueProducao)
}